import ContactEmail from "components/Contact-Email";

import useForm from "./form";

const ContactUs = ({
  page,
  heading,
  subtitle,
  hideHeading,
}: {
  page?: string;
  heading?: string;
  subtitle?: string;
  hideHeading?: boolean;
}) => {
  const { nameRef, emailRef, messageRef, onValuesChange, onSubmit, status } =
    useForm(page);
  return (
    <div>
      {!hideHeading && (
        <>
          <div className="text-center">
            <h2
              className="h2 font-extrabold leading-tighter tracking-tighter mb-4"
              data-aos="zoom-y-out"
            >
              {heading || "Contact Us"}
            </h2>
            {subtitle && (
              <div className="mx-w-3xl mx-auto">
                <p
                  className="text-xl text-gray-600 mb-8"
                  data-aos="zoom-y-out"
                  data-aos-delay="150"
                >
                  {subtitle}
                </p>
              </div>
            )}
          </div>
        </>
      )}
      <div className="w-full max-w-2xl mx-auto mb-8">
        <form onSubmit={onSubmit}>
          <div className="flex mb-4 -mx-2">
            <div className="w-1/2 px-2">
              <input
                className="appearance-none block w-full py-3 px-4 leading-tight text-gray-700 bg-gray-200 focus:bg-white border border-gray-200 focus:border-gray-500 rounded focus:outline-none"
                placeholder="Name"
                required
                ref={nameRef}
                onChange={onValuesChange}
              />
            </div>
            <div className="w-1/2 px-2">
              <input
                className="appearance-none block w-full py-3 px-4 leading-tight text-gray-700 bg-gray-200 focus:bg-white border border-gray-200 focus:border-gray-500 rounded focus:outline-none"
                type="email"
                placeholder="Email"
                required
                ref={emailRef}
                onChange={onValuesChange}
              />
            </div>
          </div>
          <div className="mb-4">
            <textarea
              className="appearance-none block w-full py-3 px-4 leading-tight text-gray-700 bg-gray-200 focus:bg-white border border-gray-200 focus:border-gray-500 rounded focus:outline-none"
              placeholder="Write something..."
              rows={5}
              required
              ref={messageRef}
              onChange={onValuesChange}
            />
          </div>
          <div>
            <button
              className={`inline-block w-full py-4 px-8 leading-none text-white ${
                status.submitted
                  ? "bg-indigo-200"
                  : "bg-indigo-500 hover:bg-indigo-600"
              } rounded shadow`}
              type="submit"
              disabled={status.submitted}
            >
              {status.submitting ? "Submitting..." : "Submit"}
            </button>
          </div>
          {status.submitted &&
            !status.submitting &&
            (status.info.error ? (
              <div
                className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 mt-3"
                role="alert"
              >
                <p className="font-bold">Unable to Send Mail</p>
                <p className="text-sm">{status.info.msg}</p>
              </div>
            ) : (
              <div
                className="bg-blue-100 border border-blue-500 text-blue-700 px-4 py-3 mt-3"
                role="alert"
              >
                <p className="font-bold">Thanks for the mail!</p>
                <p className="text-sm">We shall get back to you shortly!</p>
              </div>
            ))}
        </form>
      </div>
      <div className="text-center">
        <p className="mb-2">
          Or just email us on <ContactEmail />
        </p>
      </div>
    </div>
  );
};

export default ContactUs;
